import React, { useEffect, useState } from 'react';
import RequiredForSetting from './components/required-for-setting';
import AttachToFormNameSetting from './components/attach-to-form-name-setting';
import AddToCopyGroupSetting, { ADD_TO_COPY_GROUP_SETTING_KEY } from './components/add-to-copy-group-setting';

export const DropdownElementSettings = function FromElement({ element, duplicateElement, handlerChangeOption }) {
  const [labels, setLabels] = useState(element.inputs);
  const [label, setLabel] = useState(element.options.label);
  const [alignment, setAlignment] = useState(element.options.alignment);
  const [instructions, setInstructions] = useState(element.options.instructions);
  const [size, setSize] = useState(element.options.size);
  const [labelPlacement, setLabelPlacement] = useState(element.options.labelPlacement || 'above');

  useEffect(() => {
    setLabels(element.inputs);
    setSize(element.options.size);
    setInstructions(element.options.instructions);
    setLabel(element.options.label);
    setAlignment(element.options.alignment);
    setLabelPlacement(element.options.labelPlacement);
  }, [element]);

  const removeItem = (item) => {
    setLabels((prevState) => {
      const newState = prevState.filter((label) => label.id !== item.id);
      handlerChangeOption(newState, 'inputs', element.id);
      return newState;
    });
  };

  const addItem = () => {
    setLabels((prevState) => {
      const newState = [...prevState];
      newState.push({
        id: 'new' + new Date().getTime(),
        label: 'New Option',
      });

      handlerChangeOption(newState, 'inputs', element.id);
      return newState;
    });
  };

  return (
    <div className="tabs-item">
      <div className="property-item">
        <h3 className="form-builder-aside-property-sub-title">Label Alignment</h3>
        <div className="form-group">
          <span className="form-radio-button">
            <input
              type="radio"
              name="alignment"
              value="left"
              checked={alignment === 'left'}
              onChange={(e) => {
                handlerChangeOption(e.target.value, 'alignment', element.id);
                setAlignment(e.target.value);
              }}
            />
            <span>Left</span>
          </span>
          <span className="form-radio-button">
            <input
              type="radio"
              name="alignment"
              value="center"
              checked={alignment === 'center'}
              onChange={(e) => {
                handlerChangeOption(e.target.value, 'alignment', element.id);
                setAlignment(e.target.value);
              }}
            />
            <span>Center</span>
          </span>
          <span className="form-radio-button">
            <input
              type="radio"
              name="alignment"
              value="right"
              checked={alignment === 'right'}
              onChange={(e) => {
                handlerChangeOption(e.target.value, 'alignment', element.id);
                setAlignment(e.target.value);
              }}
            />
            <span>Right</span>
          </span>
        </div>
      </div>

      <div className="property-item">
        <h3 className="form-builder-aside-property-sub-title">Label Placement</h3>
        <div className="form-group" style={{ display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
          <div className="form-radio-button" style={{ display: 'block', flex: 1 }}>
            <input
              type="radio"
              name="labelPlacement"
              value="above"
              checked={labelPlacement === 'above'}
              onChange={(e) => {
                handlerChangeOption(e.target.value, 'labelPlacement', element.id);
                setLabelPlacement(e.target.value);
              }}
            />
            <span style={{ textAlign: 'center', display: 'block' }}>Above</span>
          </div>
          <div className="form-radio-button" style={{ display: 'block', flex: 1 }}>
            <input
              type="radio"
              name="labelPlacement"
              value="left"
              checked={labelPlacement === 'left'}
              onChange={(e) => {
                handlerChangeOption(e.target.value, 'labelPlacement', element.id);
                setLabelPlacement(e.target.value);
              }}
            />
            <span style={{ textAlign: 'center', display: 'block' }}>Left</span>
          </div>
        </div>
      </div>

      <div className="property-item">
        <h3 className="form-builder-aside-property-sub-title">Input Size</h3>
        <div className="form-group">
          <span className="form-radio-button">
            <input
              type="radio"
              name="size"
              value="small"
              checked={size === 'small'}
              onChange={(e) => {
                handlerChangeOption(e.target.value, 'size', element.id);
                setSize(e.target.value);
              }}
            />
            <span>Small</span>
          </span>
          <span className="form-radio-button">
            <input
              type="radio"
              name="size"
              value="medium"
              checked={size === 'medium'}
              onChange={(e) => {
                handlerChangeOption(e.target.value, 'size', element.id);
                setSize(e.target.value);
              }}
            />
            <span>Medium</span>
          </span>
          <span className="form-radio-button">
            <input
              type="radio"
              name="size"
              value="large"
              checked={size === 'large'}
              onChange={(e) => {
                handlerChangeOption(e.target.value, 'size', element.id);
                setSize(e.target.value);
              }}
            />
            <span>Large</span>
          </span>
        </div>
      </div>
      <div className="property-item">
        <h3 className="form-builder-aside-property-sub-title">Name Label</h3>
        <div className="form-control-item">
          <input
            type="text"
            className="form-control"
            placeholder="Enter text"
            value={label}
            onChange={(e) => {
              setLabel(e.target.value);
            }}
            onBlur={(e) => {
              handlerChangeOption(e.target.value, 'label', element.id);
              handlerChangeOption(e.target.value.replace(/ /g, '-').toLowerCase(), 'name', element.id);
            }}
          />
        </div>
      </div>
      <div className="property-item">
        <h3 className="form-builder-aside-property-sub-title">Name Options</h3>
        {labels.map((item, index) => (
          <div className="form-control-item" key={index}>
            <input
              type="text"
              className="form-control"
              placeholder="Enter text"
              value={item.label}
              onBlur={() => handlerChangeOption(labels, 'inputs', element.id)}
              onChange={(e) => {
                setLabels((prevState) => {
                  return prevState.map((label, prevIndex) => {
                    if (index === prevIndex) {
                      label.label = e.target.value;
                      label.id = e.target.value.replace(/ /g, '-').toLowerCase() + '-' + new Date().getTime();
                    }

                    return label;
                  });
                });
              }}
            />
            {labels.length > 1 && (
              <div className="settings-actions">
                <button className="btn btn-remove btn-icon" onClick={() => removeItem(item)}>
                  <i className="icon-remove"></i>
                </button>
              </div>
            )}
          </div>
        ))}
        <div className="property-item">
          <div className="form-control-item">
            <div className={`form-control-checkbox`}>
              <input
                name={'addRowsButton'}
                type="checkbox"
                checked={!!element.options.addOtherOption}
                onChange={(e) => {
                  handlerChangeOption(!element.options.addOtherOption, 'addOtherOption', element.id);
                }}
              />
              <span>Add Other option</span>
            </div>
          </div>
        </div>
        <button className="btn-link" onClick={addItem}>
          <i className="icon-plus-svgrepo-com"></i>
          Add Choice
        </button>
      </div>

      <RequiredForSetting element={element} onChange={handlerChangeOption} />

      <div className="property-item">
        <h3 className="form-builder-aside-property-sub-title">Instructions</h3>
        <div className="form-control-item">
          <textarea
            className="form-control"
            placeholder="Enter Instructions"
            value={instructions}
            onChange={(e) => {
              setInstructions(e.target.value);
            }}
            onBlur={(e) => {
              handlerChangeOption(e.target.value, 'instructions', element.id);
            }}
          ></textarea>
        </div>
      </div>

      <AttachToFormNameSetting element={element} onChange={handlerChangeOption} />
      <div className="property-item">
        <h3 className="form-builder-aside-property-sub-title">Show borders in PDF</h3>
        <div className="form-switcher">
          <input
            type="checkbox"
            name="showBorders"
            checked={element?.options?.showBorders !== false}
            onChange={(e) => {
              handlerChangeOption(e.target.checked, 'showBorders', element.id);
            }}
          />
          <span>{element?.options?.showBorders ? 'Yes' : 'No'}</span>
        </div>
      </div>
      <AddToCopyGroupSetting
        elementID={element?.id}
        selected={element?.options?.[ADD_TO_COPY_GROUP_SETTING_KEY]}
        onChange={handlerChangeOption}
      />
    </div>
  );
};
